module.exports = __webpack_public_path__ + "img/about_main2.4f68750f.jpeg";